export const common = {
  // Navbar
  'nav.overview': 'Nchịkọta',
  'nav.directory': 'Akwụkwọ Nduzi Ụka',
  'nav.worship': 'Ọrụ Ofufe',
  'nav.live': 'Ụbọchị Izu Ike Ndụ',
  'nav.ministries': 'Ozi',
  'nav.leadership': 'Ndu',
  'nav.adminLogin': 'Nbanye Admin',
  'nav.language': 'Asụsụ',
  
  // Language names
  'lang.english': 'Bekee',
  'lang.yoruba': 'Yoruba',
  'lang.hausa': 'Hausa',
  'lang.igbo': 'Igbo',
  'lang.pidgin': 'Pidgin',
  
  // Hero Section
  'hero.badge': 'Usoro Ofufe Dijitalụ Mba',
  'hero.title': 'Na-enye Ụka Seventh-day Adventist Niile na Naịjirịa Ike',
  'hero.description': 'Ikpo okwu dijitalụ jikọtara ọnụ nke na-ejikọta ụka SDA niile gafee Naịjirịa. Nweta ọrụ ofufe ndụ, chọta ụka dị nso gị, jikwaa ihe omume, ma mee ka obodo anyị sie ike site na teknụzụ.',
  'hero.exploreChurches': 'Nyochaa Ụka',
  'hero.worshipTools': 'Ngwa Ofufe',
  'hero.liveNow': 'Ndụ Ugbu a',
  'hero.scrollExplore': 'Pịgharịa iji nyochaa',
  
  // Stats
  'stats.churches': 'Ụka',
  'stats.members': 'Ndị Otu Na-arụ Ọrụ',
  'stats.liveServices': 'Ọrụ Ndụ Kwa Izu',
  'stats.events': 'Ihe Omume Kwa Ọnwa',
  
  // Features
  'features.watchLive': 'Lee Ndụ',
  'features.watchLiveDesc': 'Sonyere ọrụ ofufe ndụ sitere na ụka gafee Naịjirịa',
  'features.findChurch': 'Chọta Ụka',
  'features.findChurchDesc': 'Chọta ụka SDA na mpaghara gị na nkọwa zuru ezu',
  'features.events': 'Ihe Omume',
  'features.eventsDesc': 'Nọgide na-emelite na nnọkọ, mmemme, na ihe omume',
  'features.ministriesTitle': 'Ozi',
  'features.ministriesDesc': 'Jikọọ na ngalaba ozi dị iche iche na mmemme',
  
  // CTA
  'cta.title': 'Ị Dị Njikere Ijikọ Ụka Gị?',
  'cta.description': 'Sonyere netwọk mba ma weta nzukọ gị n\'oge dijitalụ. Nweta ngwa dị ike maka ofufe, nkwurịta okwu, na iwu obodo.',
  'cta.getStarted': 'Malite Taa',
  'cta.learnMore': 'Mụtakwuo',
  
  // Footer
  'footer.tagline': 'Na-ejikọta ụka Seventh-day Adventist gafee Naịjirịa site na ngwọta dijitalụ ọhụrụ.',
  'footer.quickLinks': 'Njikọ Ngwa Ngwa',
  'footer.resources': 'Akụrụngwa',
  'footer.contact': 'Kpọtụrụ',
  'footer.home': 'Ụlọ',
  'footer.about': 'Banyere Anyị',
  'footer.churches': 'Ụka',
  'footer.liveStream': 'Iyi Ndụ',
  'footer.worshipGuide': 'Nduzi Ofufe',
  'footer.techSupport': 'Nkwado Teknụzụ',
  'footer.training': 'Ọzụzụ',
  'footer.documentation': 'Akwụkwọ',
  'footer.email': 'Email',
  'footer.phone': 'Ekwentị',
  'footer.address': 'Adreesị',
  'footer.rights': 'Ikike niile echekwabara.',
  'footer.privacy': 'Iwu Nzuzo',
  'footer.terms': 'Usoro Ọrụ',
  
  // Directory Page
  'directory.title': 'Akwụkwọ Nduzi Ụka',
  'directory.subtitle': 'Chọta ụka Seventh-day Adventist gafee Naịjirịa',
  'directory.search': 'Chọọ ụka...',
  'directory.allRegions': 'Mpaghara Niile',
  'directory.allStates': 'Steeti Niile',
  'directory.viewDetails': 'Lee Nkọwa',
  'directory.getDirections': 'Nweta Ntuziaka',
  'directory.members': 'ndị otu',
  
  // Live Page
  'live.title': 'Ọrụ Ofufe Ndụ',
  'live.subtitle': 'Sonyere ọrụ Ụbọchị Izu Ike ndụ sitere na ụka gafee Naịjirịa',
  'live.allRegions': 'Mpaghara Niile',
  'live.watchNow': 'Lee Ugbu a',
  'live.viewers': 'ndị na-ekiri',
  'live.starting': 'Na-amalite',
  
  // Events Page
  'events.title': 'Ihe Omume Na-abịa',
  'events.subtitle': 'Chọpụta nnọkọ, ọmụmụ ihe, na mmemme gafee Naịjirịa',
  'events.allCategories': 'Ụdị Niile',
  'events.register': 'Debanye Aha Ugbu a',
  'events.learnMore': 'Mụtakwuo',
  'events.attendees': 'ndị bịara',
  
  // Ministries Page
  'ministries.title': 'Ngalaba Ozi',
  'ministries.subtitle': 'Nyochaa mmemme ozi anyị dị iche iche na ngalaba',
  'ministries.learnMore': 'Mụtakwuo',
  'ministries.programs': 'mmemme',
  
  // Tools Page
  'tools.title': 'Ngwa Ofufe',
  'tools.subtitle': 'Ngwọta dijitalụ maka njikwa ụka ọgbara ọhụrụ',
  'tools.getStarted': 'Malite',
  'tools.learnMore': 'Mụtakwuo',
};

export default {
  // ... existing code ...
  
  // New translations for enhanced landing page
  whatYouCanDo: 'Ihe I Nwere Ike Ime',
  platformDescription: 'Chọpụta ụzọ niile nke ikpo okwu anyị na-enyere gị aka ịnọgide na-ejikọta na obodo ụka gị ma too n\'okwukwe',
  learnMore: 'Mụtakwuo',
  
  howItWorks: 'Otu Ọ Si Arụ Ọrụ',
  howItWorksDesc: 'Ịmalite dị mfe. Soro usoro anọ ndị a dị mfe iji malite njem gị',
  
  discoverChurches: 'Chọpụta Ụka',
  discoverChurchesDesc: 'Nyochaa ndekọ zuru oke nke ụka Seventh-day Adventist n\'ofe Naịjirịa. Chọta ebe, oge ọrụ, na ozi kọntaktị',
  
  joinWorship: 'Sonye Na Ofufe Ndụ',
  joinWorshipDesc: 'Lee ọrụ ndị a na-egosi na ndụ site n\'ụka n\'ofe mba. Nweta ahụmịhe ofufe site n\'ebe ọ bụla, oge ọ bụla',
  
  participateEvents: 'Sonye Na Mmemme',
  participateEventsDesc: 'Nọgide na-ama ọkwa banyere nnọkọ, ọzụzụ, na mmemme obodo. Debanye aha ma sonye na mmemme na-abịa',
  
  connectCommunity: 'Jikọọ Na Obodo',
  connectCommunityDesc: 'Soro na ozi, sonye na obere otu, wuo mmekọrịta bara uru na ndị kwere ekwe ibe',
  
  whyChooseUs: 'Ihe Kpatara I Ga-ahọrọ Ikpo Okwu Anyị',
  whyChooseUsDesc: 'E wuru ya kpọmkwem maka obodo Seventh-day Adventist na Naịjirịa nwere atụmatụ ndị kacha mkpa',
  
  accessAnywhere: 'Nweta N\'ebe Ọ Bụla',
  accessAnywhereDesc: 'Jikọọ na obodo ụka gị site na ngwaọrụ ọ bụla, ma ị nọ n\'ụlọ ma ọ bụ na njem',
  
  secureReliable: 'Nchekwa & Ntụkwasị Obi',
  secureReliableDesc: 'A na-echebe data gị site na nchekwa ọkwa ụlọ ọrụ. Nwee ọrụ na-adịghị akwụsị akwụsị ị nwere ike ịtụkwasị obi',
  
  mobileOptimized: 'Emeziri Ekwentị Mkpanaaka',
  mobileOptimizedDesc: 'Nhazi nzaghachi zuru oke na-ahụ na ahụmịhe na-enweghị nsogbu na smartphones, mbadamba, na desktops',
  
  communityFocused: 'Lekwasịrị Anya Na Obodo',
  communityFocusedDesc: 'E wuru ya site na ntinye aka sitere n\'aka ndị ndu ụka na ndị otu iji jee ozi mkpa pụrụ iche nke obodo anyị',
  
  stayUpdated: 'Nọgide Na-emelite',
  stayUpdatedDesc: 'Nweta ọkwa banyere mmemme dị mkpa, nkwusa ọhụrụ, na ọkwa obodo',
  
  comprehensiveTools: 'Ngwaọrụ Zuru Oke',
  comprehensiveToolsDesc: 'Nweta usoro zuru oke nke ngwaọrụ dijitalụ e mere iji kwalite njikwa ụka na ntinye aka ndị otu'
};
